import React from 'react';
import BrandclubSideWidget from '../components/BrandclubSideWidget/index.js';

var BrandclubAffiliateRewards = function (_a) {
    var _b;
    var brandEntity = _a.brandEntity, LinkComponent = _a.LinkComponent;
    return (React.createElement(BrandclubSideWidget, { leftSideProps: {
            type: 'text',
            title: "Earn rewards to advocate for ".concat((_b = brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.entity) === null || _b === void 0 ? void 0 : _b.name),
            subtitle: 'Generate commission when you share affiliate links and drive sales from your blog posts, social, email, and more.',
            buttonText: '',
            buttonLink: { id: '', displayName: '' },
        }, rightSideProps: {
            type: 'image',
            imageUrl: "https://media.brandclub.com/brand_custom/".concat(brandEntity === null || brandEntity === void 0 ? void 0 : brandEntity.id, "/d3.png"),
            imageLink: { id: '', displayName: '' },
        }, LinkComponent: LinkComponent }));
};

export { BrandclubAffiliateRewards };
//# sourceMappingURL=index.js.map
